import React from 'react'
import {useSelector} from 'react-redux'
import {IReduxState} from '../../../redux/types/IReduxState'
import {TaskDto, TaskListItemDto} from 'learndb-share'
import {ButtonLink, Icon, THEME_COLORS} from 'ac_ui'
import {URLS} from '../../../constants/urls'
import {acCheck, acPlay} from 'ac-icon'

interface ITaskListBlockProps {
  id: string
}

const TaskListBlock: React.FC<ITaskListBlockProps> = () => {
  const task = useSelector<IReduxState, TaskDto>((state) => state.task?.task)
  const themeTasks = useSelector<IReduxState, TaskListItemDto[]>((state) => state.task?.themeTasks)
  const themeName: string = task?.themeName

  let content: React.ReactElement
  if (themeTasks) {
    const items = themeTasks.map((t, index) => (
      <li key={t.taskId} className={'task-editor-task-list-item'}>
        <a href={URLS.tasks + '/' + t.taskId} className={'task-editor-task-list-item-a'}>
          <span className={'tsi-number'}>{index + 1}.</span>
          <span className={'tsi-name'}>{t.name}</span>
          <span className={'tsi-controls'}>
            {t.isSolved ? (
              <span className={'tsi-solved'}>
                <Icon path={acCheck} color={THEME_COLORS.success} className={'mr-x1'} title={'Выполнено'} />
                <span>Выполнено</span>
              </span>
            ) : undefined}
            <span className={'tsi-unsolved'}>
              <Icon path={acPlay} color={THEME_COLORS.primary} className={'mr-x1'} title={'Начать'} />
              <span className={'tsi-text'}>Начать</span>
            </span>
          </span>
        </a>
      </li>
    ))
    content = (
      <nav>
        <ul className={'task-editor-task-list'}>{items}</ul>
      </nav>
    )
  }

  return (
    <div className={'custom-scroll h-100 pt-x6 pb-0 pr-x1 pl-x6 mr-x1'}>
      <h2 className={'task-block-header task-list-theme-name'}>{themeName}</h2>
      {content}
      <div className={'d-flex mb-x6'}>
        <ButtonLink size={'md'} style={'ghost'} href={URLS.themes}>
          Вернуться к программе
        </ButtonLink>
      </div>
    </div>
  )
}

export {TaskListBlock}
